import { Mapper } from "../../../../base/utils/mapper";
import { TypeGlassesModel } from "../../../../domain/models/consult/type-glasses.model";
import { TypeGlassesEntity } from "../entities/type-glasses.entity";

export class TypeGlassesImplementationRepositoryMapper extends Mapper<TypeGlassesEntity, TypeGlassesModel> {
    mapFrom(param: TypeGlassesEntity): TypeGlassesModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: TypeGlassesModel): TypeGlassesEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}